import { AdUnit } from "../types/prebid";
import BaseBidder from "./BaseBidder";

export default class appnexusoutstream extends BaseBidder {

	protected adUnitConfig: AdUnit = {
		code: this.slot.path,

		ssp: "Appnexus Outstream",

		sizes: [[640, 360]],

		mediaTypes: { ...this.mediaTypeOutstreamSettings },

		bids: [
			{ 
				bidder: "appnexus", 
				params: {
					placementId: this.bidderConfig.toString()
				}
			}
		]

	}
}
